import { createApp } from './vendor/petite-vue.min.js'
import { useInputSelect, useFormRules, useAnchorToError } from './modules/_form.js'

try {
  (async () => {
    const { required, checkEmail } = useFormRules()

    function checkProductCode(value) {
      return value.length === 12
    }

    function checkPurchaseChannelDistributor(value) {
      return this.purchaseChannel !== '經銷商' || (this.purchaseChannel === '經銷商' && value.length > 0)
    }

    function checkPurchaseChannelOther(value) {
      return this.purchaseChannel !== '其他' || (this.purchaseChannel === '其他' && value.length > 0)
    }

    function checkPhone(value) {
      return !value || /^09\d{8}$/.test(value)
    }

    function checkConsent(value) {
      return value
    }

		createApp({
      country: '',
      model: '',
      productCode: '',
      purchaseChannel: '',
      purchaseChannelList: ['經銷商', 'LINE 官方商城', 'Ayers 官方商城', 'Ayers 旗艦店', '其他'],
      purchaseChannelDistributor: '',
      purchaseChannelOther: '',
      name: '',
      phone: '',
      email: '',
      snsType: 'LINE',
      snsTypeList: ['LINE', 'Facebook', 'Instagram','WeChat'],
      snsId: '',
      message: '',
      consent: false,
      isAllCorrect: false,
      // validate
      rules: {
        country: { required },
        model: { required },
        productCode: { required, checkProductCode },
        purchaseChannel: { required },
        purchaseChannelDistributor: { checkPurchaseChannelDistributor },
        purchaseChannelOther: { checkPurchaseChannelOther },
        name: { required },
        phone: { checkPhone },
        email: { required, checkEmail },
        consent: { checkConsent },
      },
      errors: {},
      errorMessages: {
        required: '此欄位為必填',
        checkProductCode: '請輸入正確的 12 碼產品序號',
        checkPurchaseChannel: '請選擇購買通路',
        checkPurchaseChannelDistributor: '請輸入經銷商名稱',
        checkPurchaseChannelOther: '請輸入其他購買通路',
        checkPhone: '請輸入正確的手機號碼，例如：0912345678',
        checkEmail: '請輸入正確的電子郵件，例如：example@example.com',
        checkConsent: '請勾選同意',
      },
      isValidated: false,
      onPurchaseChannelChange() {
        this.purchaseChannelDistributor = ''
        this.setErrors()
      },
      setErrors() {
        this.errors = this.isValidated ?
          Object.entries(this.rules)
          .reduce((acc, [key, rules]) => {
            return {
              ...acc,
              [key]: Object.entries(rules).reduce((prev, [ruleName, fn]) => {
                if (!fn.call(this, this[key])) {
                  prev.push(ruleName)
                }
                return prev
              }, [])
            }
          }, {}) :
          {}
          console.log(this.errors)
      },
      useValidate() {
        this.isValidated = true
        this.setErrors()
        return Object.values(this.errors).every(item => item.length === 0)
      },
      useSubmit() {
        this.isAllCorrect = this.useValidate()

        if (!this.isAllCorrect) {
          setTimeout(() => {
            useAnchorToError()
          }, 100)
        }
      },
      // mounted
			onMounted() {
        useInputSelect()
			}
		}).mount('#app')
	})()
}
catch(error) {
	console.error(error)
}